import { render, staticRenderFns } from "./AvisoLegal.vue?vue&type=template&id=65c9ef1a&scoped=true"
import script from "./AvisoLegal.vue?vue&type=script&lang=js"
export * from "./AvisoLegal.vue?vue&type=script&lang=js"
import style0 from "./AvisoLegal.vue?vue&type=style&index=0&id=65c9ef1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9ef1a",
  null
  
)

export default component.exports